export default __webpack_public_path__ + "static/EconSansOSReg-532a69128f4e50aa252bc0814bc4aed3.woff2";